import { Entitlement, EntitlementKeys } from './types';

// TODO: Remove FB related defaults once tested more thoroughly for multiplatform
export const MockedEntitlements: Record<string, Entitlement> = {
  'analytics::trends::view': {
    key: 'analytics::trends::view',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  'integrations::fondue::setup': {
    key: 'integrations::fondue::setup',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  'analytics::subscribers::view': {
    key: 'analytics::subscribers::view',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  'analytics::messages::view': {
    key: 'analytics::messages::view',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  'analytics::reports::view': {
    key: 'analytics::reports::view',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  'integrations::browse': {
    key: 'integrations::browse',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  'ai::shopper::eligible': {
    key: 'ai::shopper::eligible',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  'brand_center::voice::view': {
    key: 'ai::brand_center::view',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },

  'acquisition::popups::view': {
    key: 'acquisition::popups::view',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  'acquisition::keywords::view': {
    key: 'acquisition::keywords::view',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  'acquisition::list_growth::view': {
    key: 'acquisition::list_growth::view',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  'acquisition::checkout::view': {
    key: 'acquisition::checkout::view',
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  [EntitlementKeys.FB_ACTIONS_EXTENDED]: {
    key: EntitlementKeys.FB_ACTIONS_EXTENDED,
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  [EntitlementKeys.FB_ADVANCED_CAMPAIGNS_USE]: {
    key: EntitlementKeys.FB_ADVANCED_CAMPAIGNS_USE,
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  [EntitlementKeys.FB_CAMPAIGNS_CONVERT]: {
    key: EntitlementKeys.FB_CAMPAIGNS_CONVERT,
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  [EntitlementKeys.FB_CAMPAIGNS_TABS_VIEW]: {
    key: EntitlementKeys.FB_CAMPAIGNS_TABS_VIEW,
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  [EntitlementKeys.FB_FILTERS_PROFILE_CORE]: {
    key: EntitlementKeys.FB_FILTERS_PROFILE_CORE,
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  [EntitlementKeys.FB_FILTERS_PROFILE_EXTENDED]: {
    key: EntitlementKeys.FB_FILTERS_PROFILE_EXTENDED,
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  [EntitlementKeys.FB_MERGE_TAGS_EXTENDED]: {
    key: EntitlementKeys.FB_MERGE_TAGS_EXTENDED,
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  [EntitlementKeys.FB_PROFILES_READ]: {
    key: EntitlementKeys.FB_PROFILES_READ,
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  [EntitlementKeys.FB_SEGMENTS_USE_MANY]: {
    key: EntitlementKeys.FB_SEGMENTS_USE_MANY,
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
  [EntitlementKeys.FB_TEMPLATES_CAMPAIGN_EXTENDED]: {
    key: EntitlementKeys.FB_TEMPLATES_CAMPAIGN_EXTENDED,
    enabled: true,
    meta: {
      internal_reason: [],
      expires_at: null,
    },
  },
};
